import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateShowDocument } from './create.generated';

export const useCreateShow = (options: ApiOptions<typeof CreateShowDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(CreateShowDocument, {
    ...useNotifications(CreateShowDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.shows.create_success'),
    }),
    ...options,
  });
};
